// extracted by mini-css-extract-plugin
export default {"background1":"#F1F2F2","categorypage":"CategoryPage_categorypage__OJbjY"};